import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_NOTIFICATIONS,
  GET_UNREAD_COUNT,
  ADD_NOTIFICATION,
  UPDATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  MARK_NOTIFICATION_AS_SEEN,
} from "./actionTypes"

import {
  getNotificationsSuccess,
  getNotificationsFail,
  getUnreadCountSuccess,
  getUnreadCountFail,
  addNotificationSuccess,
  addNotificationFail,
  updateNotificationSuccess,
  updateNotificationFail,
  deleteNotificationSuccess,
  deleteNotificationFail,
  markNotificationAsSeenSuccess,
  markNotificationAsSeenFail,
} from "./actions"

import {
  getNotificationsApi,
  getUnreadCountApi,
  addNotificationApi,
  updateNotificationApi,
  deleteNotificationApi,
  markNotificationAsSeenApi,
} from "helpers/backend_helper"

function* fetchNotifications() {
  try {
    const response = yield call(getNotificationsApi)
    yield put(getNotificationsSuccess(response))
  } catch (error) {
    yield put(getNotificationsFail(error))
  }
}

function* fetchUnreadCount() {
  try {
    const response = yield call(getUnreadCountApi)
    yield put(getUnreadCountSuccess(response))
  } catch (error) {
    yield put(getUnreadCountFail(error))
  }
}

function* onAddNotification({ payload: notification }) {
  try {
    const response = yield call(addNotificationApi, notification)
    const newNotification = { ...notification, id: response }
    yield put(addNotificationSuccess(newNotification))
  } catch (error) {
    yield put(addNotificationFail(error))
  }
}

function* onUpdateNotification({ payload: notification }) {
  try {
    yield call(updateNotificationApi, notification)
    yield put(updateNotificationSuccess(notification))
  } catch (error) {
    yield put(updateNotificationFail(error))
  }
}

function* onDeleteNotification({ payload: id }) {
  try {
    yield call(deleteNotificationApi, { id })
    yield put(deleteNotificationSuccess(id))
  } catch (error) {
    yield put(deleteNotificationFail(error))
  }
}

function* onMarkNotificationAsSeen({ payload: id }) {
  try {
    yield call(markNotificationAsSeenApi, { id })
    yield put(markNotificationAsSeenSuccess(id))
  } catch (error) {
    yield put(markNotificationAsSeenFail(error))
  }
}

function* NotificationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, fetchNotifications)
  yield takeEvery(GET_UNREAD_COUNT, fetchUnreadCount)
  yield takeEvery(ADD_NOTIFICATION, onAddNotification)
  yield takeEvery(UPDATE_NOTIFICATION, onUpdateNotification)
  yield takeEvery(DELETE_NOTIFICATION, onDeleteNotification)
  yield takeEvery(MARK_NOTIFICATION_AS_SEEN, onMarkNotificationAsSeen)
}

export default NotificationsSaga
